import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProviderCard from "../ProviderCard";
import { PROVIDERS } from "../../mock";
import { useContent } from "../../context/ContentContext";

export default function ProviderDirectory() {
  const { c } = useContent();
  const p = c.providerDirectory;
  const list = PROVIDERS.slice(0, 6);
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="eyebrow">{p.eyebrow}</p>
            <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{p.title}</h2>
          </div>
          <Link to="/providers" className="group inline-flex items-center gap-2 text-[15px] font-semibold text-[var(--brand-blue)] hover:text-[var(--brand-blue-hover)]">
            {p.linkLabel}
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((prov, i) => (
            <ProviderCard key={prov.slug} p={prov} hideEditorBadge={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
}
